<template lang="pug">
  #app.page.page--overflow
    .page__view
        .page__view-wr
            .page__decore-wr.page__decore-wr--1
                img.page__decore.page__decore--1(src='@/assets/img/decor/leaf.svg' alt="decor")
            .page__decore-wr.page__decore-wr--2
                img.page__decore.page__decore--2(src='@/assets/img/decor/cube.svg' alt="decor")
            .page__decore-wr.page__decore-wr--3
                img.page__decore.page__decore--3(src='@/assets/img/decor/straightedge.svg' alt="decor")
            .page__decore-wr.page__decore-wr--4
                img.page__decore.page__decore--4(src='@/assets/img/decor/leaf.svg' alt="decor")
            .page__decore-wr.page__decore-wr--5
                img.page__decore.page__decore--5(src='@/assets/img/decor/cube-scale.svg' alt="decor")
            .page__decore-wr.page__decore-wr--6
                img.page__decore.page__decore--6(src='@/assets/img/decor/glow-1.svg' alt="decor")
            .page__decore-wr.page__decore-wr--7
                img.page__decore.page__decore--7(src='@/assets/img/decor/cube-scale.svg' alt="decor")
            .page__decore-wr.page__decore-wr--8
                img.page__decore.page__decore--8(src='@/assets/img/decor/straightedge.svg' alt="decor")
            .page__decore-wr.page__decore-wr--9
                img.page__decore.page__decore--9(src='@/assets/img/decor/lightning.svg' alt="decor")
            .page__decore-wr.page__decore-wr--10
                img.page__decore.page__decore--10(src='@/assets/img/decor/glow-2.svg' alt="decor")
            .page__decore-wr.page__decore-wr--11
                img.page__decore.page__decore--11(src='@/assets/img/decor/leaf.svg' alt="decor")
            .page__decore-wr.page__decore-wr--12
                img.page__decore.page__decore--12(src='@/assets/img/decor/cube.svg' alt="decor")
            .page__decore-wr.page__decore-wr--13
                img.page__decore.page__decore--13(src='@/assets/img/decor/cube.svg' alt="decor")
            .page__decore-wr.page__decore-wr--14
                img.page__decore.page__decore--14(src='@/assets/img/decor/leaf.svg' alt="decor")
            .page__decore-wr.page__decore-wr--15
                img.page__decore.page__decore--15(src='@/assets/img/decor/glow-1.svg' alt="decor")
            .page__decore-wr.page__decore-wr--16
                img.page__decore.page__decore--16(src='@/assets/img/decor/glow-1.svg' alt="decor")
            .page__wr
              CartWidget
              Header
              transition(name="fade"  mode="out-in")
                router-view
              .page__bottom(v-if="width > 1100")
                  Footer(:footer="footer")
                  Samedia
    //popupCallPhone
    //popupMessage
    Preloader
</template>

<script>
  import Header from '@/components/common/header/Header';
  import Footer from '@/components/common/footer/Footer';
  import Samedia from '@/components/common/samedia/Samedia.vue';
  //import popupCallPhone from '@/components/common/popups/popupCallPhone/popupCallPhone.vue';
  //import popupMessage from '@/components/common/popups/popupMessage/popupMessage.vue';
  import Preloader from '@/components/common/preloader/Preloader.vue';
  import CartWidget from '@/components/common/cartWidget/CartWidget.vue';

  import EventBus from '@/eventBus';

  import 'perfect-scrollbar/css/perfect-scrollbar.css';
  import PerfectScrollbar from 'perfect-scrollbar';

  export default {
    components: {
      Header,
      Footer,
      Samedia,
      //popupCallPhone,
      //popupMessage,
      Preloader,
      CartWidget
    },

    data() {
        return {
            scrollbar: null,
            width: 0,
            footer: null,
            totalScroll: false,
            totalScrollBack: true,
            scrollTop: 0,
            containerHeight: 0,
            distance: 0,
            maxScroll: 0,
        }
    },

    created() {
        EventBus.$on('footerLoaded', footer => {
            this.footer = footer;
        });
    },

    mounted() {
        this.width = $(window).innerWidth();
        this.$nextTick(() => {
            // this.scrollInit();
            this.parallax();
            this.scrollPage();
        });
    },

    methods: {
        scrollPage() {
            let scrollTop = 0;
            let routerName = '',
                routerPath = '';
            $(window).on('scroll', () => {
                routerName = this.$router.currentRoute.name;
                routerPath = this.$router.currentRoute.fullPath;
                scrollTop = $(window).scrollTop();
                if($(window).scrollTop()+$(window).height()>=$(document).height()){
                    $('.samedia').removeClass('samedia--hide');
                    $('.footer').removeClass('footer--hide');
                    $('.page__decore--12').removeClass('page__decore--hide-bottom');
                    $('.page__decore--11').removeClass('page__decore--hide-bottom');
                    $('.page__decore--10').removeClass('page__decore--hide-bottom');
                } else {
                    $('.samedia').addClass('samedia--hide');
                    $('.footer').addClass('footer--hide');
                    $('.page__decore--12').addClass('page__decore--hide-bottom');
                    $('.page__decore--11').addClass('page__decore--hide-bottom');
                    $('.page__decore--10').addClass('page__decore--hide-bottom');
                }

                if(scrollTop > 100) {
                    if (routerName === 'MenuNested') {
                        $('.menu__top').removeClass('menu__top--hide');
                    }
                    else if(routerPath === '/anonsy') {
                        $('.announcements__top').removeClass('announcements__top--hide');
                    }
                    else if(routerPath === '/fotootchyoty') {
                        $('.photo-reports__top').removeClass('photo-reports__top--hide');
                    }
                    else if (routerName === 'PhotoReport') {
                        $('.photo-report__top').removeClass('photo-report__top--hide');
                    }
                } else {
                    if (routerName === 'MenuNested') {
                        $('.menu__top').addClass('menu__top--hide');
                    }
                    else if(routerPath === '/anonsy') {
                        $('.announcements__top').addClass('announcements__top--hide');
                    }
                    else if(routerPath === '/fotootchyoty') {
                        $('.photo-reports__top').addClass('photo-reports__top--hide');
                    }
                    else if (routerName === 'PhotoReport') {
                        $('.photo-report__top').addClass('photo-report__top--hide');
                    }
                }
            });
        },

        scrollInit() {
            // if($('.page__view').length) {
            //     this.scrollbar = new PerfectScrollbar('.page__view', {
            //         wheelSpeed: 1,
            //         wheelPropagation: true,
            //         minScrollbarLength: 20
            //     });
            //     EventBus.$emit('scrollbarInit', this.scrollbar);
            // }
            this.scrollbar = $('.page__view').mCustomScrollbar({
                mouseWheel: {
                    enable: true
                },
                scrollbarPosition: "outside",
                scrollEasing: "linear",
                theme: "minimal",
                callbacks: {
                    onUpdate: () => {
                        $('.page__view').mCustomScrollbar('scrollTo', 0, {
                            timeout: 0,
                            scrollInertia: 0,
                        });
                        this.containerHeight = $('.page__view').find('.mCSB_container').height();
                        if(this.containerHeight <= $(window).height()) {
                            $('.samedia').removeClass('samedia--hide');
                            $('.footer').removeClass('footer--hide');
                            $('.page__decore--12').removeClass('page__decore--hide-bottom');
                            $('.page__decore--11').removeClass('page__decore--hide-bottom');
                            $('.page__decore--10').removeClass('page__decore--hide-bottom');
                        }
                        console.log(this.containerHeight);
                        var $scrollerOuter  = $('.page__view'),
                            $dragger        = $scrollerOuter.find( '.mCSB_dragger_bar'),
                            draggerRail     = $scrollerOuter.find( '.mCSB_draggerRail');
                        // var draggerTop      = $dragger.position().top;

                        this.maxScroll = draggerRail.height() - $dragger.height();

                        console.log(100 / ($scrollerOuter.height() - $dragger.height()) * (this.containerHeight - $scrollerOuter.height()))

                        this.distance = this.maxScroll - (50 / ($scrollerOuter.height() - $dragger.height()) * (this.containerHeight - $scrollerOuter.height()));

                        console.log('d', this.distance);
                        console.log('max', this.maxScroll);
                    },

                    whileScrolling: () => {
                        this.scrollTop = $('.page__view').find(".mCSB_dragger").position().top;
                        EventBus.$emit('whileScrolling', this.scrollTop);
                        if(this.scrollTop < 200) {
                            if (this.$router.currentRoute.name == 'MenuNested') {
                                $('.menu__top').addClass('menu__top--hide');

                                $('.page__no-content-decore--6').addClass('page__no-content-decore--hide');
                                $('.page__no-content-decore--8').addClass('page__no-content-decore--hide');
                                $('.page__no-content-decore--9').addClass('page__no-content-decore--hide');
                            }
                        } else {
                            if (this.$router.currentRoute.name == 'MenuNested') {
                                $('.menu__top').removeClass('menu__top--hide');

                                $('.page__no-content-decore--6').removeClass('page__no-content-decore--hide');
                                $('.page__no-content-decore--8').removeClass('page__no-content-decore--hide');
                                $('.page__no-content-decore--9').removeClass('page__no-content-decore--hide');
                            }
                        }
                    }
                }
            });

        },

        parallax() {
            $(document).on('mousemove', event => {
                let offsetX = event.clientX,
                    offsetY = event.clientY;

                $('.page__decore-wr--1').css('transform', `translate(${offsetX * 0.02}px, ${offsetY * -0.02}px)`).find('img').css('transform', `rotate(${offsetX * offsetY * 0.00001}deg)`);
                $('.page__decore-wr--2').css('transform', `translate(${offsetX * -0.01}px, ${offsetY * 0.01}px)`).find('img').css('transform', `rotate(${offsetX * offsetY * -0.00002}deg)`);
                $('.page__decore-wr--3').css('transform', `translate(${offsetX * -0.015}px, ${offsetY * 0.02}px)`).find('img').css('transform', `rotate(${offsetX * offsetY * -0.00003}deg)`);
                $('.page__decore-wr--4').css('transform', `translate(${offsetX * 0.01}px, ${offsetY * 0.015}px)`).find('img').css('transform', `rotate(${offsetX * offsetY *- 0.00002}deg)`);
                $('.page__decore-wr--5').css('transform', `translate(${offsetX * 0.02}px, ${offsetY * -0.02}px)`).find('img').css('transform', `rotate(${offsetX * offsetY * 0.00001}deg)`);
                $('.page__decore-wr--6').css('transform', `translate(${offsetX * -0.015}px, ${offsetY * 0.01}px)`).find('img').css('transform', `rotate(${offsetX * offsetY * 0.00003}deg)`);
                $('.page__decore-wr--7').css('transform', `translate(${offsetX * 0.02}px, ${offsetY * -0.02}px)`).find('img').css('transform', `rotate(${offsetX * offsetY * -0.00002}deg)`);
                $('.page__decore-wr--8').css('transform', `translate(${offsetX * 0.01}px, ${offsetY * -0.01}px)`).find('img').css('transform', `rotate(${offsetX * offsetY * 0.00002}deg)`);
                $('.page__decore-wr--9').css('transform', `translate(${offsetX * -0.015}px, ${offsetY * 0.02}px)`).find('img').css('transform', `rotate(${offsetX * offsetY * 0.00003}deg)`);
                $('.page__decore-wr--10').css('transform', `translate(${offsetX * 0.01}px, ${offsetY * -0.015}px)`).find('img').css('transform', `rotate(${offsetX * offsetY * -0.00002}deg)`);
                $('.page__decore-wr--11').css('transform', `translate(${offsetX * -0.02}px, ${offsetY * 0.01}px)`).find('img').css('transform', `rotate(${offsetX * offsetY * 0.00001}deg)`);
                $('.page__decore-wr--12').css('transform', `translate(${offsetX * 0.015}px, ${offsetY * 0.02}px)`).find('img').css('transform', `rotate(${offsetX * offsetY *- 0.00003}deg)`);
                $('.page__decore-wr--13').css('transform', `translate(${offsetX * 0.015}px, ${offsetY * 0.02}px)`).find('img').css('transform', `rotate(${offsetX * offsetY *- 0.00003}deg)`);
                $('.page__decore-wr--14').css('transform', `translate(${offsetX * 0.01}px, ${offsetY * 0.015}px)`).find('img').css('transform', `rotate(${offsetX * offsetY *- 0.00002}deg)`);
                $('.page__decore-wr--15').css('transform', `translate(${offsetX * -0.015}px, ${offsetY * 0.01}px)`).find('img').css('transform', `rotate(${offsetX * offsetY * 0.00003}deg)`);
                $('.page__decore-wr--16').css('transform', `translate(${offsetX * -0.015}px, ${offsetY * 0.01}px)`).find('img').css('transform', `rotate(${offsetX * offsetY * 0.00003}deg)`);
            });
        },
    }
  }
</script>
